var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showLoader)?_c('div',{staticClass:"loader"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.loader)}})]):_vm._e(),(!_vm.showLoader && _vm.url)?_c('div',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"allow":"fullscreen","src":_vm.url}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }